
import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import Vue from 'vue'

import router from './router'
import store from './store'
import vant from 'vant';
import 'vant/lib/index.css';

createApp(App).use(store).use(router).use(vant).use(createPinia()).mount('#app')
